<div class="add-respondent">
    <div class="modal-body">
        <div *ngIf="!isMultipleMode" class="head m-b-20">
            Adding respondents for the apraisee <span class="font-weight-bold">{{ appraiseeName }}</span>
        </div>
        <div  *ngIf="isMultipleMode" class="head m-b-20">
            Adding respondents for selected apraisees
        </div>
        <div class="row m-t-10">
            <div class="col-md-5 caption">
                Business unit:<br />
                <ngx-select 
                [items]="businessUnits"
                optionValueField="id"
                optionTextField="name"
                [allowClear]="true" 
                (remove) = "clearBusinessUnit()" 
                (select)="selectBusinessUnit($event)" 
                placeholder=""></ngx-select>
            </div>
            <div class="col-md-5 caption">
                Respondents:<br />
                <ngx-select
                [items]="respondents" 
                optionValueField="id"
                optionTextField="name"
                [allowClear]="true" 
                (remove) = "clearSelectedRespondent()" 
                (select)="selectPerson($event)" (typed)="searchRespondentsByName($event)" placeholder=""></ngx-select>
            </div>
        </div>
        <br>
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <input id="checkboxPME" type="checkbox" [(ngModel)]="isPMEChecked" [disabled]="!knownProcessTypes.includes(processTypes.PME)">
                    <label for="checkboxPME">PME</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <input id="checkboxPMQ" type="checkbox" [(ngModel)]="isPMQChecked" [disabled]="!knownProcessTypes.includes(processTypes.PMQ)">
                    <label for="checkboxPMQ">PMQ</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <input id="checkboxCombined" type="checkbox" [(ngModel)]="isCombinedChecked" [disabled]="!knownProcessTypes.includes(processTypes.Combined)">
                    <label for="checkboxCombined">Combined</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-1">
                    <input id="checkbox360" type="checkbox" [(ngModel)]="is360Checked" [disabled]="!knownProcessTypes.includes(processTypes._360)">
                    <label for="checkbox360">360 </label>
                </div>
                <div class="col-md-1">
                </div>
                <div class="col-md-5" *ngIf="is360Checked">                    
                    <ngx-select 
                        [items]="_360Types" 
                        optionValueField="id"
                        optionTextField="text"
                        [(ngModel)]="selected360Type"
                        [allowClear]="false" 
                        placeholder="">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="btn-modal">
            <span (click)="addRespondents()">Add</span>
            <span (click)="hideModal()">Cancel</span>
        </div>
    </div>
</div>